<script lang="ts" setup>
import { toggleDark } from "~/composables";
import uzFlag from '@/assets/images/icons/uz-flag.svg'
import { ref } from "vue";
// import { version } from '~/../package.json'
import BaseIcon from "../BaseIcon.vue";
import { useRouter } from "vue-router";
import { useLogout } from "~/service/auth";
import BaseUserAvatar from "../BaseUserAvatar.vue";
import { useAuthStore } from '~/stores/auth'
import {storeToRefs} from "pinia"
import { useTranslate } from "~/composables/useTranslate";
const {user} = storeToRefs(useAuthStore());
const {translateKey} = useTranslate();

const globalSearchValue = ref('')
const router = useRouter()
</script>

<template>
  <div class="tw-flex tw-items-end tw-justify-between tw-pl-[24px]">

    <div class="general-search__wrapper">
      <el-input
        v-model="globalSearchValue"
        style="max-width: 600px; max-height: 37px;"
        :placeholder="translateKey('Umumiy qidirish')"
        size="large"
      >
        <template #append>
          <button
            class="general-search_button tw-flex tw-items-center tw-text-[#737687] tw-space-x-2 tw-px-[12px] tw-border-l-[1px] tw-border-solid tw-border-[#F8F9FF] tw-w-[100%] tw-h-[100%] tw-bg-[#fff] tw-cursor-pointer"
            :class="{ 'no-hover': !globalSearchValue }"
            style="border-radius: 0 12px 12px 0;"
          >
            <BaseIcon name="Search"></BaseIcon>
            <span class="tw-text-[14px] tw-font-normal tw-leading-[150%] tw-m-0 tw-p-0">
              {{ translateKey('Izlash') }}
            </span>
          </button>
        </template>
      </el-input>
    </div>
    
    <div class="tw-w-[100%] tw-flex tw-justify-end tw-items-center tw-gap-[20px] tw-pr-[32px] tw-pt-[24px]">
      <el-menu background-color="#F8F9FF" class="tw-flex tw-h-max tw-bg-[#F8F9FF] tw-justify-end tw-items-center tw-gap-[20px] el-menu-demo tw-border-b-0" mode="horizontal" :ellipsis="false">
        <LangSwitcher></LangSwitcher>
        <el-menu-item index="2" class="hover:tw-bg-transparent tw-px-0 tw-h-max">
          <BaseIcon name="Settings" />
        </el-menu-item>
        <el-menu-item index="3" class="hover:tw-bg-transparent tw-px-0 tw-h-max">
          <BaseIcon name="Bell" />
        </el-menu-item>
      </el-menu>
      <!-- <LangSwitcher></LangSwitcher> -->
      <el-row class="tw-w-max">
        <el-col>
          <el-dropdown trigger="click">
            <div>
              <!-- <pre>{{user}}</pre> -->
              <div v-if="user?.images?.length" class="w-[32px] h-[32px] rounded-[50%]">
                <img class="w-[32px] h-[32px] rounded-[50%] tw-object-contain" :src="user?.images[0]?.original_url" alt="profile" width="32" height="32">
              </div>
              <div v-else class="tw-w-[32px] rounded-[50%]" >
                  <BaseUserAvatar></BaseUserAvatar>
              </div>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <button @click="() => router.push('/cabinet/profile')" class="tw-flex tw-items-center tw-gap-[8px] text-[14px] text-[#737687] font-medium leading-[150%] m-0 p-0">
                    <BaseIcon name="User"></BaseIcon>
                    <span>
                      {{ translateKey("Shaxsiy kabinet") }}
                    </span>
                  </button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button @click="useLogout()" class="tw-flex tw-items-center tw-gap-[8px] text-[14px] text-[#737687] font-medium leading-[150%] m-0 p-0">
                    <BaseIcon name="Logout"></BaseIcon>
                    <span>
                      {{ translateKey("Tizimdan chiqish") }}
                    </span>
                  </button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss">
.el-menu-demo {
  &.ep-menu--horizontal > .ep-menu-item:nth-child(1) {
    margin-right: auto;
  }
}
.user-me .ep-sub-menu__icon-arrow {
    display: none !important;
  }
.user-me .ep-sub-menu__title {
    padding-left: 0px !important;
    padding-right: 40px !important;
  }
.header_language .ep-sub-menu__title {
    padding: 0px !important;
  }
.header_language .ep-icon  {
  display: none;
}
.general-search__wrapper {
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0px 6px 12px 0px rgba(79, 87, 139, 0.04) !important;
}
.general-search__wrapper .ep-input--large .ep-input__inner {
  color: #181818;
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
  margin: 0;
  padding: 0;
}
.general-search__wrapper .ep-input__wrapper {
  color: #181818 !important;
  box-shadow: unset !important;
  border-radius: 12px 0px 0px 12px !important;
}
.general-search__wrapper .ep-input-group__append {
  box-shadow: unset !important;
  border-radius: 12px 0px 0px 12px !important;
  padding: 0px;
}
.general-search_button {
  transition: background-color 0.3s ease, color 0.3s ease;
}
.general-search_button:not(.no-hover):hover {
  background-color: #3361FF !important;
  color: white !important;
  cursor: pointer;
}
.general-search_button.no-hover {
  background-color: #fff !important;
  color: #737687 !important;
  cursor: not-allowed !important;
}

</style>
